<script setup lang='ts'>
import type { AuthorWork } from '~/utils/solr/author-work'

const props = defineProps<{
  title: string
  works: AuthorWork[]

}>()

const INITIAL_VISIBLE_WORKS = 4

const expanded = ref<boolean>(false)

const visibleWorks = computed(() => {
  if (expanded.value) {
    return props.works
  }
  return props.works.slice(0, INITIAL_VISIBLE_WORKS)
})

const hasMore = computed(() => props.works.length > INITIAL_VISIBLE_WORKS)
</script>

<template>
  <section class="flex flex-col gap-l">
    <h2 class="title-s font-semibold">
      {{ title }}
    </h2>

    <TransitionGroup tag="ul" name="works" class="flex gap-s flex-col sm:flex-row sm:flex-wrap">
      <li v-for="work in visibleWorks" :key="work.id">
        <AcademicArticleCard v-if="work.nodeType === 'academic_article'" :doc="work" size="small" class="w-[358px] sm:w-[307px]" />
        <ContentCard v-else :item="work" size="small" class="w-[358px] sm:w-[307px]" />
      </li>
    </TransitionGroup>
    <Button v-if="hasMore" size="small" variant="text" class="mx-auto" @click="expanded = !expanded">
      {{ expanded ? 'Vis færre' : `Vis alle (${props.works.length})` }}
    </Button>
  </section>
</template>

<style scoped lang="postcss">
.works-enter-active {
  transition:
    opacity 0.5s ease-out,
    transform 0.5s ease-out;
}

.works-leave-active {
  transition:
    opacity 0.4s ease-in,
    transform 0.4s ease-in;
}

.works-enter-from {
  opacity: 0;
  transform: translateY(12px);
}

.works-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

:deep(.academic-article-card) {
  --card-container-bg: theme('colors.white');
}
</style>
